import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/app/providers/ThemeProvider";
import { ToasterProvider } from "@/app/providers/Toaster";
import { ConfirmProvider } from "@/app/providers/ConfirmDialog";
import { AppRouter } from "@/app/router";
import { useSession } from "@/lib/auth/session";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  const hydrate = useSession((s) => s.hydrate);

  useEffect(() => {
    hydrate();
  }, [hydrate]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToasterProvider>
          <ConfirmProvider>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </ConfirmProvider>
        </ToasterProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
